export default __webpack_public_path__ + "static/media/waving-bot-200.a427de6d.png";